export const logErrorToDatadog = (error: unknown, context?: Record<any, any>) =>
  window.DD_RUM?.addError(error, context);
